import React, { useState } from 'react';
import TopNavigation from '../components/TopNavigation';
import LeftPanel from '../components/LeftPanel';
import MainContent from '../components/MainContent';
import RightPanel from '../components/RightPanel';

const DashboardPage = () => {
    const [isLeftPanelCollapsed, setIsLeftPanelCollapsed] = useState(false);
    const [isRightPanelOpen, setIsRightPanelOpen] = useState(true);
    const [selectedService, setSelectedService] = useState('Agents');

    const toggleLeftPanel = () => setIsLeftPanelCollapsed(!isLeftPanelCollapsed);
    const toggleRightPanel = () => setIsRightPanelOpen(!isRightPanelOpen);

    return (
        <div className="d-flex flex-column vh-100 bg-light"> {/* Changed to Bootstrap classes */}
            <TopNavigation />

            <div className="d-flex flex-grow-1 overflow-hidden"> {/* Changed to Bootstrap classes */}
                <LeftPanel
                    isCollapsed={isLeftPanelCollapsed}
                    togglePanel={toggleLeftPanel}
                    selectedService={selectedService}
                    onServiceSelect={setSelectedService}
                />

                <MainContent selectedService={selectedService} />

                <RightPanel
                    isOpen={isRightPanelOpen}
                    togglePanel={toggleRightPanel}
                    selectedService={selectedService}
                />
            </div>
        </div>
    );
};

export default DashboardPage;